import Vue from "vue";
import Router from "vue-router";
import { api } from "@/state/services";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/",
      component: () => import("./views/home"),
      meta: { authRequired: true, },
    },
    {
      path: "/cadastrar",
      component: () => import("./views/cadastrar"),
      meta: { authRequired: false, },
    },
    {
      path: "/login",
      component: () => import("./views/login/index"),
      meta: { authRequired: false, },
    },
    {
      path: "/login/token/:token",
      component: () => import("./views/login/token"),
      meta: { authRequired: false, },
    },
    {
      path: "/logout",
      redirect: "/login",
    },
    {
      path: "/login/recuperar-senha",
      component: () => import("./views/login/senha-recuperar"),
      meta: { authRequired: false, },
    },
    {
      path: "/login/alterar-senha",
      component: () => import("./views/login/senha-alterar"),
      meta: { authRequired: false, },
    },
    {
      path: "/configuracoes",
      component: () => import("./views/configuracoes/index"),
      meta: { authRequired: true, },
    },
    {
      path: "/configuracoes/assinatura",
      component: () => import("./views/configuracoes/assinatura"),
      meta: { authRequired: true, },
    },
    {
      path: "/configuracoes/assinatura/faturas/:id",
      component: () => import("./views/configuracoes/assinatura-fatura"),
      meta: { authRequired: true, },
    },
    {
      path: "/configuracoes/alterar-senha",
      component: () => import("./views/configuracoes/alterar-senha"),
      meta: { authRequired: true, },
    },
    {
      path: "/financeiro",
      component: () => import("./views/financeiro/index"),
      meta: { authRequired: true, },
    },
    {
      path: "/financeiro/adicionar",
      component: () => import("./views/financeiro/adicionar"),
      meta: { authRequired: true, },
    },
    {
      path: "/clientes",
      component: () => import("./views/clientes/index"),
      meta: { authRequired: true, },
    },
    {
      path: "/clientes/cadastrar",
      component: () => import("./views/clientes/cadastrar"),
      meta: { authRequired: true, },
    },
    {
      path: "/clientes/importar",
      component: () => import("./views/clientes/importar"),
      meta: { authRequired: true, },
    },
    {
      path: "/clientes/importar/:id",
      component: () => import("./views/clientes/importar_arquivo"),
      meta: { authRequired: true, },
    },
    {
      path: "/clientes/:id",
      component: () => import("./views/clientes/editar"),
      meta: { authRequired: true, },
    },
    {
      path: "/pedidos",
      component: () => import("./views/pedidos/index"),
      meta: { authRequired: true, },
    },
    {
      path: "/pedidos/:id",
      component: () => import("./views/pedidos/ver"),
      meta: { authRequired: true, },
    },
    {
      path: "/produtos",
      component: () => import("./views/produtos/index"),
      meta: { authRequired: true, },
    },
    {
      path: "/ferramentas",
      component: () => import("./views/ferramentas/index"),
      meta: { authRequired: true, },
    },
    {
      path: "/integracoes",
      component: () => import("./views/integracoes/index"),
      meta: { authRequired: true, },
    },
    {
      path: "/integracoes/shopee",
      component: () => import("./views/integracoes/shopee"),
      meta: { authRequired: true, },
    },
    {
      path: "/integracoes/shopee/auth",
      component: () => import("./views/integracoes/shopee-auth"),
      meta: { authRequired: false, },
    },
    {
      path: "/courses",
      component: () => import("./views/courses/list"),
      meta: { authRequired: true, },
    },
    {
      path: "/courses/:course",
      component: () => import("./views/courses/view"),
      meta: { authRequired: true, },
    },
    {
      path: "/courses/:course/:module/:lesson",
      component: () => import("./views/courses/view"),
      meta: { authRequired: true, },
    },
    {
      path: "/tutoriais",
      component: () => import("./views/tutoriais/index"),
      meta: { authRequired: true, },
    },
    {
      path: "/suporte",
      component: () => import("./views/suporte/index"),
      meta: { authRequired: true, },
    },
    {
      path: "/suporte/:id",
      component: () => import("./views/suporte/view"),
      meta: { authRequired: true, },
    },
    {
      path: "/404",
      component: () => import("./views/404"),
      meta: { authRequired: false, },
    },
  ],
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem("token");

  document.title = process.env.VUE_APP_TITLE;
  next();

  if (to.meta.authRequired && !loggedIn) {
    return next("/login");
  }

  if (to.meta.authRequired && loggedIn) {
    api
      .get("user")
      .then((response) => {
        if (response.data && response.data.status == "success") {
          next();
        } else {
          return next("/login");
        }
      })
      .catch(error => {
        if (error) {
          return next("/login");
        }
      });
  } else {
    next();
  }
});

export default router;
